import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Footer";
import {
  Snackbar,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Navbar from "../components/Navbar";
import DOMPurify from "dompurify";
import apiClient from "../components/apiClient";
import Clock from "../assets/Clock.png";
import { use } from "react";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});
function Checkout() {
  const [cart, setCart] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [cartLoading, setCartLoading] = useState(true);
  const [addressLoading, setAddressLoading] = useState(true);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [products, setProducts] = useState([]);
  const [showPopup, setShowPopup] = useState(false); // State to control the pop-up visibility
  const [productSpecs, setProductSpecs] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [courier, setCourier] = useState("jne");
  const [origin, setOrigin] = useState(null);
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [editingAddress, setEditingAddress] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [snapUrl, setSnapUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState(""); // Message for success or error
  const [isError, setIsError] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const onClose = () => {
    setIsOpen(false); // Close modal or similar
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic
  };

  const [isEditPopupVisible, setIsEditPopupVisible] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState({
    namapenerima: "",
    nomerteleponpenerima: "",
  });

  const handleAddressSelects = () => {
    setIsAddressSelected(true);
  };

  useEffect(() => {
    const totalCartWeight = cart.reduce((acc, item) => {
      const product = item.Produk || item.produk;
      return acc + product.berat * item.jumlah; // Multiply weight by quantity
    }, 0);
    setTotalWeight(totalCartWeight); // Update total weight
    localStorage.setItem("totalWeight", totalCartWeight / 1000);
  }, [cart]);

  useEffect(() => {
    const fetchOrigin = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/origin`,
        );
        const data = await response.json();
        console.log("Origin API Response:", data); // Debugging response
        if (data && data[0] && data[0].kotaId) {
          setOrigin(data[0].kotaId); // Use kotaId from the response
        } else {
          console.error("No origin city ID found in the response.");
        }
      } catch (error) {
        console.error("Error fetching origin:", error);
      }
    };

    fetchOrigin();
  }, []); // This runs once when the component mounts

  console.log("Selected Address Kota ID:", selectedAddress?.kotaId);

  const handleCourierChange = (e) => {
    setCourier(e.target.value);
  };
  console.log(setCourier);

  const handleOptionSelect = (option) => {
    setSelectedOption(option); // Store the selected option
  };

  const handleAddressSubmit = async (event) => {
    event.preventDefault();

    // Check if required fields are filled
    if (
      !formData.namapenerima ||
      !formData.alamat ||
      // !formData.kotaataukelurahan ||
      !selectedCity ||
      // !formData.provinsi ||
      !selectedProvince ||
      !formData.kodePos
    ) {
      setSnackbarMessage("Please fill out all required fields.");
      setOpenSnackbar(true);
      return;
    }

    // If status is 'Utama', check if another address already has 'Utama' status
    if (formData.status === "Utama") {
      const existingMainAddress = addresses.find(
        (address) => address.status === "Utama",
      );
      if (existingMainAddress && existingMainAddress.id !== formData.id) {
        setSnackbarMessage("You can only have one main address.");
        setOpenSnackbar(true);
        return;
      }
    }

    // Final formData with province and city
    const finalFormData = {
      ...formData,
      provinsi: selectedProvince?.nama || selectedProvince, // Ensure it's name
      kotaataukelurahan: selectedCity?.nama || selectedCity,
    };

    try {
      let response;
      if (editingAddress) {
        response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/alamat/${editingAddress.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(finalFormData),
          },
        );
      } else {
        response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/alamat`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(finalFormData),
        });
        console.log(finalFormData);
        // const data = await response.json();
        // console.log("API Response:", data);
      }

      if (response.ok) {
        const data = await response.json();
        if (editingAddress) {
          setAddresses((prev) =>
            // prev.map((address) => (address.id === data.id ? data : address))
            prev.map((address) =>
              address.id === data.address.id ? data.address : address,
            ),
          );
          setSnackbarMessage("Address updated successfully!");
        } else {
          setAddresses((prev) => [...prev, data]);
          setSnackbarMessage("Address added successfully!");
        }
        // setOpenAddDialog(false);
        // setOpenEditDialog(false);
        setOpenSnackbar(true);
        window.location.reload();
      } else {
        const error = await response.json();
        console.error("API error response:", error);
        setSnackbarMessage(
          `Failed to submit address: ${error.message || "Unknown error"}`,
        );
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error submitting address:", error);
      setSnackbarMessage("Failed to submit address. Please try again later.");
      setOpenSnackbar(true);
    }
  };

  const handleInputsChange = (e) => {
    const { name, value } = e.target;
    setAddressToEdit((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditAddress = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/alamat/${addressToEdit.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(addressToEdit),
        },
      );

      if (response.ok) {
        const updatedAddress = await response.json();
        setAddresses((prevAddresses) =>
          prevAddresses.map((addr) =>
            addr.id === updatedAddress.id ? updatedAddress : addr,
          ),
        );
        closeEditPopup();
      } else {
        const error = await response.json();
        alert(`Failed to update address: ${error.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error updating address:", error);
      alert("Failed to update address. Please try again later.");
    }

    console.log("Updated Address:", addressToEdit);
    setIsEditPopupVisible(false);
  };

  const closeEditPopup = () => {
    setIsEditPopupVisible(false);
  };

  const openEditPopup = (address) => {
    setAddressToEdit(address);
    setIsEditPopupVisible(true);
  };

  const navigate = useNavigate();

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      setAddressLoading(true);
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token not found");

        const addressResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/alamat`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!addressResponse.ok) {
          throw new Error(
            `Address fetch failed with status: ${addressResponse.status}`,
          );
        }

        const addresses = await addressResponse.json();
        setAddresses(addresses || []);
      } catch (error) {
        console.error("Failed to fetch addresses", error);
        setAddresses([]);
      } finally {
        setAddressLoading(false);
      }
    };

    // Retrieve the full cart data from localStorage
    const storedSelectedCartItems =
      JSON.parse(localStorage.getItem("selectedCartItems")) || [];
    console.log("Stored selected cart items:", storedSelectedCartItems); // Debug log
    setCart(storedSelectedCartItems); // Set cart state with full items (not just ids)

    const fetchProductData = async () => {
      const productIds = storedSelectedCartItems.map((item) => item.produkId); // Extract produkId from cart items

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/produk/all`,
        );
        if (!response.ok) {
          throw new Error(`Error fetching products: ${response.statusText}`);
        }

        const allProducts = await response.json();

        const selectedProducts = allProducts.filter((product) =>
          productIds.includes(product.id),
        );

        // Ensure all selected products have the `spesifikasi` field available
        setProducts(selectedProducts);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        toast.error("Failed to fetch products. Please try again later.");
      }
    };

    fetchAddresses();
    fetchProductData();

    setCurrentStep(2);
    setCompletedSteps([true, false, false, false, false]);
  }, []);

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  const calculateTotal = (selectedCart) => {
    return selectedCart.reduce((total, item) => {
      const produk = item.produk || item.Produk || {};
      const hargaArray = produk.harga || [];
      const basePrice = Number(hargaArray[0]) || 0;
      const quantity = Number(item.jumlah) || 0;
      const discountPercentage = Number(produk.diskon) || 0;

      const priceAfterDiscount =
        discountPercentage > 0
          ? basePrice - (basePrice * discountPercentage) / 100
          : basePrice;

      const itemTotal = priceAfterDiscount * quantity;

      return total + itemTotal;
    }, 0);
  };

  const [promoCode, setPromoCode] = useState("");
  const [promoDiscount, setPromoDiscount] = useState(0); // store discount percent
  const [promoPrice, setPromoPrice] = useState(0);
  const [promoActive, setpromoActive] = useState(false);
  const [promoData, setPromoData] = useState(null);
  const [promoApplied, setPromoApplied] = useState(false);

  // const handleApply = async () => {
  //   if (!promoCode) return;

  //   try {
  //     const token = localStorage.getItem("token");

  //     // 🔹 Step 1: Validate base promo
  //     const response = await apiClient.get(`/kodepromo/promo/${promoCode}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });

  //     const promo = response?.data?.kodepromo;
  //     if (!promo) {
  //       throw new Error("Promo not found");
  //     }

  //     console.log("✅ Base Promo:", promo);

  //     let potongan = 0;
  //     // let diskonPersen = 0;
  //     // let diskonNilai = 0;

  //     const diskonPersen = response?.data?.kodepromo?.diskon || 0;
  //     console.log(diskonPersen);
  //     const diskonNilai = response?.data?.kodepromo?.diskon_nilai || 0;
  //     const produkId = response?.data?.kodepromo?.produkId || null;

  //     // ✅ Save the whole promo info into state
  //     setPromoData({
  //       produkId,
  //       diskon: diskonPersen,
  //       diskon_nilai: diskonNilai,
  //       promo_produk: promo.promo_produk,
  //     });

  //     // 🔹 CASE 1: General promo (applies to whole cart)
  //     if (promo.promo_produk === "N") {
  //       // use directly from this endpoint
  //       // const diskonPersen = promo.diskon || 0;
  //       const diskonPersen = response?.data?.kodepromo?.diskon || 0;
  //       // const diskonNilai = promo.diskon_nilai || 0;
  //       const diskonNilai = response?.data?.kodepromo?.diskon_nilai || 0;

  //       const total = calculateTotal(cart);
  //       if (diskonPersen > 0) {
  //         potongan = total * (diskonPersen / 100);
  //       } else {
  //         potongan = diskonNilai;
  //       }
  //     }
  //     // 🔹 CASE 2: Product-specific promo
  //     else if (promo.promo_produk === "Y") {
  //       let totalPotongan = 0;

  //       for (const item of cart) {
  //         const productId = item.produkId || item.produk?.id || item.Produk?.id;

  //         try {
  //           // Check promo specifically for this product
  //           const productResponse = await apiClient.get(
  //             `/kodepromo/produk/${productId}/${promoCode}`,
  //             {
  //               headers: { Authorization: `Bearer ${token}` },
  //             }
  //           );

  //           const productPromo =
  //             productResponse.data?.data || productResponse.data;
  //           console.log(`🎯 Product ${productId} promo:`, productPromo);

  //           // 🔑 Only apply if user input promoCode matches the code from API
  //           if (productPromo?.kode === promoCode) {
  //             const subtotal = Number(item.subtotal) || 0;

  //             const ppDiskon = productPromo.diskon || 0;
  //             const ppDiskonNilai = productPromo.diskon_nilai || 0;

  //             if (ppDiskon > 0) {
  //               totalPotongan += subtotal * (ppDiskon / 100);
  //             } else if (ppDiskonNilai > 0) {
  //               totalPotongan += ppDiskonNilai;
  //             }

  //             // ✅ store last applied values (or could aggregate if needed)
  //             diskonPersen = ppDiskon;
  //             diskonNilai = ppDiskonNilai;

  //             console.log("👉 Ambil dari API:", {
  //               ppDiskon,
  //               ppDiskonNilai,
  //               diskonPersen,
  //               diskonNilai,
  //             });
  //           } else {
  //             console.log(
  //               `❌ Promo code ${promoCode} not valid for product ${productId}`
  //             );
  //           }
  //         } catch (err) {
  //           console.warn(
  //             `❌ Error checking promo for product ${productId}`,
  //             err
  //           );
  //         }
  //       }

  //       potongan = totalPotongan;
  //       console.log("💰 Product-specific potongan:", potongan);
  //       console.log(
  //         "📌 diskonPersen:",
  //         diskonPersen,
  //         "diskonNilai:",
  //         diskonNilai
  //       );
  //     }
  //     console.log(diskonPersen);
  //     console.log("sampai sini");

  //     // 🔹 Save promo info
  //     localStorage.setItem("diskonPersen", diskonPersen);
  //     localStorage.setItem("diskonNilai", diskonNilai);
  //     localStorage.setItem("diskonId", promo.id);
  //     localStorage.setItem("potongan", potongan);

  //     setPromoDiscount(potongan);
  //     setPromoPrice(potongan);
  //     setpromoActive(potongan);

  //     setpromoActive(true);

  //     console.log("💰 Final Potongan:", potongan);
  //     setMessage("Promo code applied successfully!");
  //     toast.success("Promo code applied successfully!", {
  //       toastId: "promo-success",
  //     });
  //     setIsError(false);
  //   } catch (error) {
  //     const backendMessage =
  //       // error?.response?.data?.message || "Promo code is invalid or expired.";
  //       error?.response?.data?.message;
  //     console.error("Error applying promo code:", error);
  //     setMessage(backendMessage);
  //     toast.error("Promo code is invalid or expired.", {
  //       toastId: "promo-error",
  //     });
  //     setIsError(true);
  //   }
  // };

  const handleApply = async () => {
    if (!promoCode) return;

    try {
      const token = localStorage.getItem("token");

      // 🔹 Step 1: Validate promo code via API
      const response = await apiClient.get(`/kodepromo/promo/${promoCode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const promo = response?.data?.kodepromo;
      if (!promo) {
        throw new Error("Promo not found");
      }

      console.log("✅ Base Promo:", promo);

      let potongan = 0;
      let diskonPersen = promo.diskon || 0;
      let diskonNilai = promo.diskon_nilai || 0;
      const produkId = promo.produkId || null;

      // ✅ Save promo info into React state
      setPromoData({
        produkId,
        diskon: diskonPersen,
        diskon_nilai: diskonNilai,
        promo_produk: promo.promo_produk,
      });

      // 🔹 CASE 1: General promo for all products
      if (promo.promo_produk === "N") {
        const total = calculateTotal(cart);
        potongan =
          diskonPersen > 0 ? total * (diskonPersen / 100) : diskonNilai;
      }

      // 🔹 CASE 2: Product-specific promo
      else if (promo.promo_produk === "Y") {
        let totalPotongan = 0;

        // ✅ Get cart items from localStorage
        const selectedCartItems =
          JSON.parse(localStorage.getItem("selectedCartItems")) || [];

        // ✅ Filter only those with kodepromo.diskon > 0
        const promoItems = selectedCartItems.filter(
          (item) =>
            item?.produk?.kodepromo &&
            (parseFloat(item.produk.kodepromo.diskon) > 0 ||
              parseFloat(item.produk.kodepromo.diskon_nilai) > 0),
        );

        console.log("🎯 promoItems:", promoItems);

        // ✅ Calculate discount for each item
        promoItems.forEach((item, i) => {
          const harga = parseFloat(item.produk?.harga?.[0]) || 0;
          const diskon = parseFloat(item.produk?.kodepromo?.diskon) || 0;
          const diskonNilai =
            parseFloat(item.produk?.kodepromo?.diskon_nilai) || 0;

          let potonganItem = 0;

          // ✅ Percentage discount
          if (diskon > 0) {
            potonganItem = (harga * diskon) / 100;
            console.log(
              `🧾 ${i + 1}. ${item.produk?.nama_produk} — Diskon ${diskon}%`,
            );
          }

          // ✅ Fixed value discount
          else if (diskonNilai > 0) {
            potonganItem = diskonNilai;
            console.log(
              `🧾 ${i + 1}. ${item.produk?.nama_produk} — Diskon Rp ${diskonNilai}`,
            );
          }

          totalPotongan += potonganItem;
        });

        potongan = totalPotongan;
        console.log("💰 Total Potongan from product promos:", potongan);
      }

      // ✅ Store everything in localStorage
      localStorage.setItem("diskonPersen", diskonPersen);
      localStorage.setItem("diskonNilai", diskonNilai);
      localStorage.setItem("diskonId", promo.id);
      localStorage.setItem("potongan", potongan);

      setPromoDiscount(potongan);
      setPromoPrice(potongan);
      setpromoActive(potongan);
      setpromoActive(true);

      console.log("💰 Final Potongan ya:", potongan);
      setMessage("Promo code applied successfully!");
      toast.success("Promo code applied successfully!", {
        toastId: "promo-success",
      });
      setIsError(false);
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message || "Promo code is invalid or expired.";
      console.error("Error applying promo code:", error);
      setMessage(backendMessage);
      toast.error("Promo code is invalid or expired.", {
        toastId: "promo-error",
      });
      setIsError(true);
    }
  };

  const rawTotal = calculateTotal(cart); // original cart total
  const promoHarga = promoPrice > 0 ? rawTotal - promoPrice : null; // only apply if discount exists
  const totalPrice = promoHarga || rawTotal;

  console.log(calculateTotal);
  localStorage.setItem("rawTotal", rawTotal);
  console.log(rawTotal);

  localStorage.setItem("totalPrice", totalPrice);
  console.log("harga promo:", promoHarga);

  console.log(totalPrice);

  const handleAddressSelect = (address) => {
    setSelectedAddress(address); // Simpan ke state
    localStorage.setItem("selectedAddressId", address.id); // Simpan id alamat ke localStorage
    localStorage.setItem("selectedAddress", JSON.stringify(address));
  };

  let colorsData = {};

  const fetchColors = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/color`,
      );
      const data = await response.json();
      colorsData = data.colorList.reduce((acc, color) => {
        acc[color.color_hex.toLowerCase()] = color.color_name;
        return acc;
      }, {});
    } catch (error) {
      console.error("Failed to fetch colors:", error);
    }
  };

  const hexToName = (hex) => {
    return colorsData[hex.toLowerCase()] || hex;
  };

  const ya = localStorage.getItem("orderId");
  console.log(ya);

  const nextDelivery = async () => {
    const totalPrice = parseFloat(localStorage.getItem("totalPrice")) || 0;
    if (!selectedAddress) {
      toast("You must select a shipping address to continue.", {
        type: "warning",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    try {
      // Step 1: Fetch shipper zipcode from company data
      const companyRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/company`,
      );
      const companyData = await companyRes.json();
      const shipper_zipcode = companyData[0]?.kodepospengirim;

      if (!shipper_zipcode) throw new Error("Shipper zipcode not found");

      // Step 2: Extract receiver zipcode from selected address
      const address = selectedAddress.alamat;
      const receiver_zipcode = selectedAddress.kodePos;
      const totalWeightFromStorage =
        parseFloat(localStorage.getItem("totalWeight")) || 0;
      console.log("totalWeightFromStorage:", totalWeightFromStorage);
      const payload = {
        shipper_zipcode,
        address,
        receiver_zipcode,
        weight: totalWeightFromStorage, // in kg
        item_value: totalPrice, // adjust as needed
      };
      console.log("payload:", payload);

      // Step 3: Send request to rajaongkir calculate endpoint
      // const res = await fetch(
      //   `${process.env.REACT_APP_API_BASE_URL}/rajaongkir/calculate`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(payload),
      //   }
      // );

      // if (!res.ok) {
      //   const errData = await res.json();
      //   throw new Error(errData.message || "Failed to calculate delivery cost");
      // }

      // const result = await res.json();
      // console.log("Delivery cost result:", result);

      localStorage.setItem("deliveryResult", JSON.stringify(payload)); // Optional

      window.location.href = "/delivery-page";
    } catch (error) {
      console.error("Delivery calculation failed:", error);
      toast.error("Failed to calculate delivery cost. Please try again.");
    }
  };

  const prevStep = () => {
    if (currentStep === 2) {
      navigate("/cart");
    } else if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStepIndicator = (stepIndex, stepNumber) => {
    return completedSteps[stepIndex] ? (
      <FaCheckCircle size={45} color="#1D1615" />
    ) : (
      <div className="w-6 h-6 rounded-full border-2 border-[#1D1615] flex items-center justify-center bg-white">
        <span style={{ fontSize: "20px", color: "#1D1615" }}>{stepNumber}</span>
      </div>
    );
  };

  // Show pop-up with product specification when clicked
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [hoveredProductId, setHoveredProductId] = useState(null); // State untuk melacak produk yang di-hover

  // Perbaiki fungsi handleProductSpecificationClick
  const handleProductSpecificationClick = (product) => {
    console.log("Clicked product:", product);
    setSelectedProductId(product.nama_produk); // Simpan ID produk yang diklik
    setShowPopup(true); // Tampilkan pop-up
  };

  // Perbaiki closePopup untuk reset selectedProductId
  const closePopup = () => {
    console.log("Closing popup...");
    setShowPopup(false);
    setSelectedProductId(null); // Reset ID produk yang dipilih
  };

  const [formData, setFormData] = useState({
    namapenerima: "",
    alamat: "",
    kotaataukelurahan: "",
    provinsi: "",
    kodePos: "",
    main: "Rumah",
    nomeralamat: "",
    nomerteleponpenerima: "",
    status: "Utama",
    provinsiId: "",
    kotaId: "",
  });

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/propinsi`,
        );
        if (!response.ok) {
          const text = await response.text();
          console.error("Server responded with:", response.status, text);
          return;
        }
        const json = await response.json();
        setProvinces(json || []);
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces();
  }, []);

  // Fetch cities when province changes
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedProvince) return;

      try {
        const response = await fetch(
          // `${process.env.REACT_APP_API_BASE_URL}/rajaongkir/cities?province=${selectedProvince}`
          `${process.env.REACT_APP_API_BASE_URL}/kota`,
        );

        if (!response.ok) {
          const text = await response.text();
          console.error("City fetch error:", response.status, text);
          return;
        }

        const json = await response.json();
        const filteredCities = json.filter(
          (city) => city.propinsiId === parseInt(selectedProvince),
        );
        setCities(filteredCities || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [selectedProvince]);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "provinsi") {
      const selectedProvince = provinces.find(
        (province) => province.province === value,
      );
      if (selectedProvince) {
        setFormData((prevData) => ({
          ...prevData,
          provinsiId: selectedProvince.province_id,
        }));
        setCities(selectedProvince.province_id);
      }
      setFormData((prevData) => ({
        ...prevData,
        kotaataukelurahan: "",
        kotaId: "",
      }));
    }

    if (name === "kotaataukelurahan") {
      const selectedCity = cities.find((city) => city.city_name === value);
      if (selectedCity) {
        setFormData((prevData) => ({
          ...prevData,
          kotaId: selectedCity.city_id,
        }));
      }
    }
  };

  fetchColors();

  const steps = ["Cart", "Shipping", "Delivery", "Payment", "Summary"];

  return (
    <>
      <Navbar />
      <div className="mt-28 mb-28 px-10 md:px-40 bg-gray-100">
        <ToastContainer />

        {/* <div className="flex justify-between items-center mb-6 md:mb-8 lg:mb-10"> */}
        <div className="flex flex-nowrap justify-between items-center space-x-2 overflow-x-auto mb-6 md:mb-8 lg:mb-10">
          {["Cart", "Shipping", "Delivery", "Payment", "Summary"].map(
            (step, index) => (
              <div
                key={index}
                className="relative flex items-center text-sm md:text-base lg:text-lg font-medium text-gray-800 flex-shrink-0"
              >
                {/* Step Circle */}
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold 
          ${index < 1 ? "bg-black" : "bg-gray-300"}`}
                >
                  {index < 1 ? "✔" : index + 1}
                </div>

                {/* Step Name */}
                <p className="ml-3 whitespace-nowrap">{step}</p>

                {/* Connector Line */}
                {/* {index < 4 && (
                  <div className="absolute left-full ml-3 top-1/2 transform -translate-y-1/2 w-12 md:w-16 lg:w-20 border-b-4 border-gray-700"></div>
                )} */}
                {index < 4 && (
                  <div className="hidden sm:block absolute left-full ml-3 top-1/2 transform -translate-y-1/2 w-12 md:w-16 lg:w-20 border-b-4 border-gray-700"></div>
                )}
              </div>
            ),
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            {currentStep === 2 && (
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center md:text-left">
                  Your Shipping Address
                </h2>
                {addressLoading ? (
                  <p className="text-center text-lg">Loading addresses...</p>
                ) : (
                  <div className="text-center mb-6">
                    <p className="text-xl md:text-2xl font-extrabold mb-4">
                      {addresses.length === 0
                        ? "You do not have any addresses added to your account."
                        : ""}
                    </p>
                    {/* Address Cards */}
                    {addresses.length > 0 && (
                      <div className="flex-row text-left">
                        {addresses.map((address) => {
                          const isPrimary = address.status === "Utama";
                          return (
                            <div
                              key={address.id}
                              className="relative bg-white p-6 rounded-lg shadow hover:shadow-md transition w-full mb-4"
                            >
                              <div className="mb-4">
                                <h3 className="text-lg font-bold">
                                  {address.main}
                                  <span className="text-sm text-gray-500 ml-2">
                                    ({isPrimary ? "Primary" : "Other address"})
                                  </span>
                                </h3>
                                <p className="text-base font-semibold">
                                  {address.namapenerima}
                                </p>
                                <p className="text-sm text-gray-700">
                                  {address.nomerteleponpenerima}
                                </p>
                                <p className="text-sm text-gray-700 mt-2">
                                  {address.alamat}, {address.kecamatan},{" "}
                                  {address.kelurahan}, {address.kota},{" "}
                                  {address.provinsi}, {address.kodePos}
                                </p>
                              </div>

                              <div className="absolute top-3 right-3">
                                <input
                                  type="checkbox"
                                  checked={selectedAddress?.id === address.id}
                                  onChange={() => handleAddressSelect(address)}
                                  className="w-6 h-6 accent-black cursor-pointer"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className=" text-right">
                      {" "}
                      <button
                        onClick={() => setOpenForm(true)}
                        className="bg-black text-white text-lg font-semibold py-3 px-6 rounded hover:bg-gray-800 transition"
                      >
                        ADD NEW ADDRESS
                      </button>
                    </div>
                    {/* Dialog Form */}
                    <Dialog
                      open={openForm}
                      onClose={() => setOpenForm(false)}
                      fullWidth
                      maxWidth="sm"
                    >
                      <DialogTitle className="text-xl font-bold text-center">
                        {editingAddress ? "Edit Address" : "Add New Address"}
                      </DialogTitle>
                      <DialogContent>
                        <form
                          onSubmit={handleAddressSubmit}
                          className="space-y-4 p-2 md:p-4 text-sm md:text-base"
                        >
                          <TextField
                            label="Recipient Name"
                            name="namapenerima"
                            value={formData.namapenerima}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            className="bg-white rounded-md"
                          />
                          <TextField
                            label="Recipient's phone number"
                            name="nomerteleponpenerima"
                            value={formData.nomerteleponpenerima}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            type="tel"
                            onKeyDown={(e) => {
                              // Block any key that is not a digit, backspace, delete, arrows
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                              ];
                              if (
                                !/[0-9]/.test(e.key) &&
                                !allowedKeys.includes(e.key)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            className="bg-white rounded-md"
                          />
                          <TextField
                            label="Address"
                            name="alamat"
                            value={formData.alamat}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            className="bg-white rounded-md"
                          />

                          <FormControl fullWidth margin="normal">
                            <InputLabel id="province-label">
                              Provinsi
                            </InputLabel>
                            <Select
                              labelId="province-label"
                              id="province-select"
                              value={selectedProvince}
                              label="Provinsi"
                              onChange={(e) => {
                                setSelectedProvince(e.target.value);
                                setSelectedCity(""); // reset city
                              }}
                            >
                              {Array.isArray(provinces) &&
                                provinces.map((province) => (
                                  <MenuItem
                                    key={province.id}
                                    value={province.id}
                                  >
                                    {province.nama}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>

                          {/* City Select */}
                          <FormControl
                            fullWidth
                            margin="normal"
                            disabled={!selectedProvince}
                          >
                            <InputLabel id="city-label">Kota</InputLabel>
                            <Select
                              labelId="city-label"
                              id="city-select"
                              value={selectedCity}
                              label="Kota"
                              onChange={(e) => setSelectedCity(e.target.value)}
                            >
                              {Array.isArray(cities) &&
                                cities.map((city) => (
                                  <MenuItem key={city.id} value={city.nama}>
                                    {city.nama}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                          <TextField
                            label="Postal Code"
                            name="kodePos"
                            value={formData.kodePos}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            className="bg-white rounded-md"
                          />
                          {/* <TextField
                            label="Address Number"
                            name="nomeralamat"
                            value={formData.nomeralamat}
                            onChange={handleInputChange}
                            fullWidth
                            className="bg-white rounded-md"
                          /> */}

                          {/* <FormControl
                            fullWidth
                            required
                            className="bg-white rounded-md"
                          >
                            <InputLabel>Main Address</InputLabel>
                            <Select
                              name="main"
                              value={formData.main}
                              onChange={handleInputChange}
                              label="Main Address"
                            >
                              <MenuItem value="Rumah">Rumah</MenuItem>
                              <MenuItem value="Kantor">Kantor</MenuItem>
                            </Select>
                          </FormControl> */}

                          <FormControl
                            fullWidth
                            required
                            className="bg-white rounded-md"
                          >
                            <InputLabel>Status</InputLabel>
                            <Select
                              name="status"
                              value={formData.status}
                              onChange={handleInputChange}
                              label="Status"
                            >
                              <MenuItem value="Utama">Utama</MenuItem>
                              <MenuItem value="Alamat lain">
                                Alamat lain
                              </MenuItem>
                            </Select>
                          </FormControl>

                          <DialogActions className="flex justify-end gap-3 pt-2">
                            <Button
                              onClick={() => setOpenForm(false)}
                              className="bg-gray-200 hover:bg-gray-300 text-black px-4 py-2 rounded"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              className="bg-black hover:bg-gray-700 text-white px-4 py-2 rounded"
                            >
                              {editingAddress ? "Update" : "Add"} Address
                            </Button>
                          </DialogActions>
                        </form>
                      </DialogContent>
                    </Dialog>
                  </div>
                )}
              </div>
            )}

            {/* for button mobile */}
            {/* <div className="block md:hidden mt-8 relative flex justify-end gap-5 md:gap-6 lg:gap-8">
              <button
                onClick={prevStep}
                disabled={currentStep === 1}
                className="w-[227px] h-14 text-lg border border-gray-800 text-gray-900 bg-white transition-all duration-300 ease-in-out 
               hover:bg-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {currentStep === 2 ? "Cancel" : "Previous"}
              </button>

              <button
                onClick={nextDelivery}
                disabled={currentStep === 4}
                className="w-[227px] h-14 text-lg text-white bg-gray-900 transition-all duration-300 ease-in-out 
               hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div> */}
          </div>

          <div className="md:block md:mt-[80px] overflow-y-auto">
            <div className="product-selected">
              {cart.length === 0 ? (
                <p></p>
              ) : (
                <>
                  {cart.map((item, index) => {
                    const product = item?.Produk || item?.produk;
                    console.log(
                      "Product index",
                      index,
                      product?.nama_produk,
                      "preorder:",
                      item?.preorder,
                    );

                    if (!product) return null; // Skip if product is missing

                    const brand = product?.brand || {};
                    const quantity = Number(item.jumlah) || 1;
                    const color = item.colorName || "N/A";
                    const subtotal = parseFloat(item.subtotal) || 0;
                    const discount = parseFloat(product.diskon) || 0;
                    const productPromo = product?.kodepromo || {};

                    const promoTargetId = promoData?.produkId; // <-- declare properly!
                    const promoDiscount = promoData?.diskon || 0;
                    const promoValue = promoData?.diskon_nilai || 0;
                    const promoNilai = Number(productPromo.diskon_nilai) || 0;
                    console.log("Brand:", brand);
                    console.log("productPromo:", productPromo);
                    console.log("promoNilai:", promoNilai);
                    console.log("promoDiscount:", promoDiscount);

                    let finalPrice = subtotal;
                    if (discount > 0) {
                      finalPrice -= (finalPrice * discount) / 100;
                    }

                    // Parse image safely
                    let images = product.image || [];
                    try {
                      if (typeof images === "string")
                        images = JSON.parse(images);
                    } catch (e) {
                      console.error("Error parsing product.image:", e);
                      images = [];
                    }

                    const firstImage =
                      images.length > 0 ? images[0] : "/placeholder.png";

                    const thisProductPromoPrice =
                      item?.produkId === promoTargetId ? promoPrice : null;

                    return (
                      <div
                        key={item?.id || item?.produkId}
                        className="bg-white p-4 rounded-lg rounded-b-none shadow-md"
                      >
                        {/* <div className="flex flex-col md:flex-row md:items-center gap-4 border-b-2 border-black"> */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
                          {/* Product Image */}
                          <div className="flex-shrink-0">
                            <img
                              src={firstImage}
                              alt={product.nama_produk}
                              className="w-36 h-48 object-cover rounded-lg"
                            />
                          </div>
                          {/* Product Details */}
                          <div className="flex-1">
                            <h2 className="text-lg font-semibold">
                              {brand.nama_brand} {product.nama_produk}
                            </h2>

                            {item?.preorder === "Y" && (
                              <div className="relative w-full text-start">
                                <div className="bg-white text-[#CCAB5C] py-1 font-semibold text-base md:text-lg flex items-center gap-2">
                                  <img
                                    src={Clock}
                                    alt="Clock icon"
                                    className="h-6 w-6"
                                  />{" "}
                                  Pre-Order
                                </div>
                              </div>
                            )}
                          </div>
                          {/* Pricing & Other Details */}
                          <div className="md:text-right">
                            <p className="text-sm">Quantity: {quantity}</p>
                            <p className="text-sm">
                              Weight: {(product.berat || 0) / 1000} Kg
                            </p>
                            <p className="text-sm">Color: {color}</p>

                            <div className="mt-2">
                              <p className="font-bold text-lg">
                                {formatRupiah(finalPrice)}
                              </p>
                              {discount > 0 && (
                                <p className="text-gray-500 line-through text-sm">
                                  {formatRupiah(subtotal)}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* {promoActive && promoNilai > 0 && (
                          
                          <div className="flex justify-between items-center p-4 border-b-2 border-black">
                            {message && (
                              <span
                                style={{ color: isError ? "red" : "#00E676" }}
                              >
                                {message}
                              </span>
                            )}

                            
                            {!isError && (
                              <span
                                className="text-sm md:text-md font-bold"
                                style={{ color: "#00E676" }}
                              >
                                -{formatRupiah(promoNilai)}
                              </span>
                            )}
                          </div>
                        )} */}

                        {/* ✅ Show message + discount row ONLY for product-specific promo */}
                        {promoData?.promo_produk === "Y" &&
                          promoActive &&
                          promoNilai > 0 && (
                            <div className="flex justify-between items-center p-4 border-b-2 border-black">
                              {message && (
                                <span
                                  style={{ color: isError ? "red" : "#00E676" }}
                                >
                                  {message}
                                </span>
                              )}
                              {!isError && (
                                <span
                                  className="text-sm md:text-md font-bold"
                                  style={{ color: "#00E676" }}
                                >
                                  -{formatRupiah(promoNilai)}
                                </span>
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </>
              )}
              <div className="flex flex-col sm:flex-row gap-2 pl-2 pr-2 bg-white">
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md sm:rounded-r-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Discount code (case sensitive)"
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
                <div className="flex justify-end md:justify-center sm:block">
                  <button
                    onClick={handleApply}
                    className="bg-black text-white px-4 py-2 w-1/2 sm:w-full rounded-md sm:rounded-l-none hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500"
                  >
                    Apply
                  </button>
                </div>
              </div>

              {/* {message && (
                <p
                  className={`p-2 text-sm bg-white ${
                    isError ? "text-red-600" : "text-green-600"
                  }`}
                >
                  {message}
                </p>
              )} */}

              {/* ✅ Show message ONLY for general promo */}
              {promoData?.promo_produk === "N" && message && (
                <p
                  className={`p-2 text-sm bg-white ${
                    isError ? "text-red-600" : "text-green-600"
                  }`}
                >
                  {message}
                </p>
              )}
            </div>

            {/* <div className="rounded-b-lg bg-white h-[100px] p-5 mb-8"> */}
            <div className="bg-white p-5">
              <h3>
                <strong>Total Weight:</strong>
              </h3>
              <p>{localStorage.getItem("totalWeight")} Kg</p>{" "}
              {/* Menampilkan total weight */}
            </div>

            {cart.length === 0 ? (
              <p></p>
            ) : (
              <>
                {/* <div className="bg-white p-5 md:p-6 lg:p-8 rounded-lg shadow-md mb-14"> */}
                <div className="bg-white p-5 md:p-6 shadow-md text-gray-500">
                  <div className="flex justify-between items-center">
                    <span className="text-md md:text-xl font-bold">
                      Subtotal
                    </span>
                    <span className="text-md md:text-xl font-bold">
                      {formatRupiah(parseFloat(rawTotal) || 0)}
                    </span>
                  </div>
                  {parseFloat(localStorage.getItem("totalPrice")) !==
                    parseFloat(localStorage.getItem("rawTotal")) && (
                    <div className="flex justify-between items-center">
                      <span className="text-md md:text-xl font-bold">
                        Discount
                      </span>

                      {/* <span className="text-md md:text-xl font-bold">
                        {(() => {
                          const potongan =
                            parseFloat(localStorage.getItem("potongan")) || 0;

                          if (potongan > 0) {
                            // ✅ Show product-specific promo discount (from handleApply)
                            return formatRupiah(potongan);
                          }

                          if (promoData?.diskon > 0) {
                            // ✅ Show percentage-based discount (general promo)
                            return formatRupiah(
                              (calculateTotal(cart) * promoData.diskon) / 100
                            );
                          }

                          // ✅ Otherwise show fixed promo discount
                          return formatRupiah(parseFloat(promoPrice) || 0);
                        })()}
                      </span> */}

                      <span className="text-md md:text-xl font-bold">
                        {(() => {
                          const potongan =
                            parseFloat(localStorage.getItem("potongan")) || 0;
                          const selectedCartItems =
                            JSON.parse(
                              localStorage.getItem("selectedCartItems"),
                            ) || [];

                          // 🧮 Calculate total quantity of promo-eligible items
                          const totalQty = selectedCartItems.reduce(
                            (sum, item) => {
                              const hasPromo =
                                item?.produk?.kodepromo &&
                                parseFloat(item.produk.kodepromo.diskon) > 0;
                              return hasPromo
                                ? sum + (parseInt(item.jumlah) || 1)
                                : sum;
                            },
                            0,
                          );

                          if (potongan > 0) {
                            // ✅ Multiply potongan by total quantity of promo items
                            return formatRupiah(potongan * totalQty);
                          }

                          if (promoData?.diskon > 0) {
                            // ✅ Show percentage-based discount
                            return formatRupiah(
                              (calculateTotal(cart) * promoData.diskon) / 100,
                            );
                          }

                          // ✅ Otherwise show fixed promo discount
                          return formatRupiah(parseFloat(promoPrice) || 0);
                        })()}
                      </span>
                    </div>
                  )}
                </div>
                <div className="relative bg-white p-5 md:p-6 lg:p-8 rounded-bl-lg rounded-br-lg shadow-md mb-14">
                  {/* 80% width border line (centered) */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[90%] h-px bg-gray-200"></div>

                  <div className="flex justify-between items-center">
                    <span className="text-2xl md:text-3xl font-bold">
                      Total
                    </span>
                    <span className="text-2xl md:text-3xl font-bold">
                      {formatRupiah(parseFloat(totalPrice || 0))}
                    </span>
                  </div>

                  <p className="text-center text-sm md:text-base text-gray-500 mt-6">
                    By confirming this order, you agree to our{" "}
                    <span
                      onClick={() => navigate("/term-page")}
                      className="cursor-pointer hover:underline"
                    >
                      Terms and Conditions
                    </span>{" "}
                    and{" "}
                    <span
                      onClick={() => navigate("/privacy-page")}
                      className="cursor-pointer hover:underline"
                    >
                      Privacy Policy
                    </span>
                  </p>
                </div>
              </>
            )}

            {/* Button Container at Bottom-Right */}
            <div className="mt-8 relative flex justify-end gap-5 md:gap-6 lg:gap-8">
              <button
                onClick={prevStep}
                disabled={currentStep === 1}
                className="w-[227px] h-14 text-lg border border-gray-800 text-gray-900 bg-white transition-all duration-300 ease-in-out 
               hover:bg-red-600 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {currentStep === 2 ? "Cancel" : "Previous"}
              </button>

              <button
                onClick={nextDelivery}
                disabled={currentStep === 4}
                className="w-[227px] h-14 text-lg text-white bg-gray-900 transition-all duration-300 ease-in-out 
               hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Product Specification Popup */}

        {showPopup && selectedProductId && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg w-11/12 max-w-md mx-auto p-6 flex flex-col overflow-hidden">
              {/* Find product by selected ID */}
              {/* Debug */}
              {console.log("✅ Selected Product ID:", selectedProductId)}
              {console.log("📦 Products:", products)}
              {products
                .filter((p) => p.nama_produk === selectedProductId)
                .map((product) => (
                  <React.Fragment key={product.nama_produk}>
                    {/* Product Specification */}
                    <div className="flex-grow overflow-y-auto max-h-60 mb-4">
                      <h3 className="text-lg font-semibold mb-2 text-gray-800">
                        Product Specifications
                      </h3>
                      <p
                        className="text-gray-600 text-sm"
                        dangerouslySetInnerHTML={sanitizeHTML(
                          product.spesifikasi || "No spesification available.",
                        )}
                      ></p>
                    </div>
                  </React.Fragment>
                ))}

              {/* Close Button */}
              <div className="text-center">
                <button
                  onClick={closePopup}
                  className="bg-black text-white px-6 py-2 rounded-full text-sm hover:bg-gray-800 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {isEditPopupVisible && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg w-11/12 max-w-lg p-6 relative overflow-y-auto max-h-[90vh]">
              {/* Title */}
              <h2 className="text-xl font-bold mb-6 text-center">
                {isEditing ? "Edit Address" : "Add New Address"}
              </h2>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Recipient Name */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Recipient Name
                  </label>
                  <input
                    type="text"
                    name="namapenerima"
                    value={formData.namapenerima}
                    onChange={handleInputChange}
                    required
                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
                  />
                </div>

                {/* Recipient's Phone Number */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Recipient's Phone Number
                  </label>
                  <input
                    type="text"
                    name="nomerteleponpenerima"
                    value={formData.nomerteleponpenerima}
                    onChange={handleInputChange}
                    required
                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
                  />
                </div>

                {/* Address */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Address
                  </label>
                  <textarea
                    name="alamat"
                    value={formData.alamat}
                    onChange={handleInputChange}
                    required
                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
                    rows={3}
                  ></textarea>
                </div>

                {/* Province */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Province
                  </label>
                  <select
                    name="provinsi"
                    value={formData.provinsi}
                    onChange={handleInputChange}
                    required
                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
                  >
                    <option value="">Select Province</option>
                    {provinces.map((province) => (
                      <option
                        key={province.province_id}
                        value={province.province}
                      >
                        {province.province}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div>
                  <label className="block text-sm font-medium mb-1">City</label>
                  <select
                    name="kotaataukelurahan"
                    value={formData.kotaataukelurahan}
                    onChange={handleInputChange}
                    required
                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
                  >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                      <option key={city.city_id} value={city.city_name}>
                        {city.city_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Buttons */}
                <div className="flex justify-end gap-4 pt-4">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 rounded-full border border-gray-300 hover:bg-gray-100 transition text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition text-sm"
                  >
                    {isEditing ? "Update" : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Checkout;
